import React from "react";
import PropTypes from 'prop-types';
import { Modal, Button } from "react-bootstrap";
import { openPolicyPdf } from "utils/policyPdf";
import companyLogo from "../../../assets/img/company_logo.png"

export default function PolicyPreviewModal({
  show,
  onHide,
  policy,
  canEdit,
  onEdit,
}) {
  console.log("policy:",policy);
  const title = policy?.title || "";
  const titleWordCount = title?.trim().split(/\s+/).length;
  const isLongTitle = titleWordCount > 5;
  
  if (!policy) return null;

  return (
    <Modal show={show} onHide={onHide} size="xl" centered scrollable className="policy-view-modal">
      <Modal.Header>
        <Modal.Title className="policy-header-title">{policy.title || "Policy Preview"}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ background: "#e9ecef" }}>
        <div className="preview-header d-flex justify-content-between align-middle">
          <div className="header-logo">
            <img className="company-logo mb-3" src={companyLogo} alt="Logo" height="40" />
            <p>
              <strong>Created By:</strong> {policy.createdBy || "--"}
            </p>
            <p>
              <strong>Created At:</strong>{" "}
              {policy.createdAt ? new Date(policy.createdAt).toLocaleDateString() : "-"}
            </p>
          </div>
          <div className="header-right">
            {!isLongTitle && (
              <h4 className="m-0">{title}</h4>
            )}
            <p className="mb-3">
              <strong>Version:</strong>{" "} {policy.version || "--"}
            </p>
            {policy.updatedAt && (
              <p>
                <strong>Updated By:</strong> {policy.updatedBy || "-"}
              </p>
            )}
            {policy.updatedAt && (
              <p>
                <strong>Updated At:</strong>{" "}
                {new Date(policy.updatedAt).toLocaleDateString()}
              </p>
            )}
          </div>
        </div>
        {isLongTitle && (
          <div className="policy-long-title mb-0 ">
            <h3 className="mb-0">{title}</h3>
            <hr />
          </div>
        )}
        <div
          id="policy-preview" className="policy-preview"
          dangerouslySetInnerHTML={{
            __html: policy.contentHtml || "",
          }}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" className="btn-cancel-cta" onClick={onHide}>
          Close
        </Button>
        <Button variant="outline-primary" className="btn-view" onClick={() => openPolicyPdf(policy)}>
          View PDF
        </Button>
        {canEdit && (
          <Button variant="primary" className="primary-btn ml-4 mt-0 pl-4 pr-4" onClick={() => onEdit(policy.id)}>
            Edit Policy
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

PolicyPreviewModal.propTypes = {
  // Top-level props
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  canEdit: PropTypes.bool,
  onEdit: PropTypes.func,

  // The nested object structure
  policy: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    title: PropTypes.string,
    contentHtml: PropTypes.string,
    version: PropTypes.string,
    createdBy: PropTypes.string,
    createdAt: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    updatedBy: PropTypes.string,
    updatedAt: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  }).isRequired, // Use .isRequired if the modal shouldn't exist without a policy
};
